import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHotjarComponent } from './simple-icons-hotjar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHotjarComponent ],
    exports:      [ SimpleIconsHotjarComponent ],
    bootstrap:    []
})
export class SimpleIconsHotjarModule {}
